import { Dropdown as Dropdowns } from 'primereact/dropdown';  

const Dropdown = ({...rest}) => {

    return (
        <Dropdowns {...rest} />
    )

};

export default Dropdown;